import { __assign } from "tslib";
import { notificationDTOToParams } from './index';
import { createWebNotificationsApi } from './';
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder } from '../test-utils';
export var createWebNotificationsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWebNotificationsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetNotifications: function (dto) {
            return createFakeGetResponder(fakeHttp, "/web-notifications" + (dto === '*' ? '' : notificationDTOToParams(dto)));
        },
        whenGetUnseenCount: function (_) { return createFakeGetResponder(fakeHttp, '/web-notifications/unseen/count'); },
        // tslint:disable-next-line:max-line-length
        whenResetUnseenCount: createFakePostResponder(fakeHttp, '/web-notifications/unseen/reset'),
        whenSetReadStatus: function (dto) {
            return createFakePostResponder(fakeHttp, "/web-notifications/" + dto.id + "/setReadStatus")(dto);
        },
        whenMarkAllRead: createFakePostResponder(fakeHttp, 'web-notifications/markRead'),
        whenCreateAnnouncement: function (dto) {
            return createFakePostResponder(fakeHttp, 'web-notifications/announcement')(dto);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map